import React, { useState, useRef, useEffect } from "react";

const OnboardingStep3 = ({ activeItems, toggleSubMenu, handleNext }) => {
  const [sliderValue, setSliderValue] = useState(0);
  const sliderRef = useRef(null); // Reference to the slider input

  const isActive = (item) => activeItems.includes(item);

  const handleToggle = (item, index) => {
    const groupItems = [
      "pain-0",
      "pain-1",
      "pain-2",
      "pain-3",
      "pain-4",
      "pain-5",
      "pain-6",
      "pain-7",
      "pain-8",
      "pain-9",
      "pain-10",
    ];
    groupItems.forEach((activeItem) => {
      if (isActive(activeItem)) {
        toggleSubMenu(activeItem);
      }
    });
    toggleSubMenu(item);

    // Update the slider value based on the selected item
    setSliderValue(index);
  };

  const groupItems = [
    "pain-0",
    "pain-1",
    "pain-2",
    "pain-3",
    "pain-4",
    "pain-5",
    "pain-6",
    "pain-7",
    "pain-8",
    "pain-9",
    "pain-10",
  ];

  const painLevels = [
    "No Pain",
    "Mild",
    "Minor",
    "Uncomfortable",
    "Moderate",
    "Distracting",
    "Distressing",
    "Severe",
    "Intense",
    "Excruciating",
    "Painful",
  ];

  const handleSliderChange = (event) => {
    const value = parseFloat(event.target.value);
    setSliderValue(value);

    // Determine which item to activate based on the current slider value
    const itemIndex = Math.round(value);
    const selectedItem = groupItems[itemIndex];

    // Activate the selected item
    handleToggle(selectedItem, itemIndex);
  };

  const handleSliderRelease = () => {
    const snappedValue = Math.round(sliderValue); // Snap to nearest integer
    setSliderValue(snappedValue);

    // Determine which item to activate based on the snapped value
    const itemIndex = snappedValue;
    const selectedItem = groupItems[itemIndex];

    // Activate the selected item
    handleToggle(selectedItem, itemIndex);

    // Save the sliderValue to localstorage as pain_level
    localStorage.setItem("pain_level", snappedValue);
  };

  const calculateGradientColor = () => {
    const startColor = [21, 177, 215]; // #15B1D7 (light blue)
    const endColor = [252, 100, 72]; // #FC6448 (red)
    const ratio = sliderValue / 10;

    const currentColor = startColor.map((start, index) =>
      Math.round(start + ratio * (endColor[index] - start))
    );

    return `rgb(${currentColor.join(",")})`;
  };

  // Calculate the bubble position to align it with the thumb
  const calculateBubblePosition = () => {
    const slider = sliderRef.current;
    if (!slider) return "0%";

    const thumbWidth = 24; // Thumb width in pixels
    const sliderWidth = slider.offsetWidth;
    const value = sliderValue / 10; // Normalize slider value to [0, 1]
    const position = value * (sliderWidth - thumbWidth) + thumbWidth / 2; // Adjust position to align with the center of the thumb

    return `${position}px`;
  };

  return (
    <div className="modal-container animated-onboarding onboarding-step3 fadeIn">
      <div className="modal-container-title fade1 heading">
        How would you rate your knee pain right now?
      </div>
      <div className="modal-contect-title fade2 subheading">
        This helps us understand where you’re starting from.
      </div>
      <div className="slider-container fade2">
        <div className="slider-labels">
          <input
            ref={sliderRef}
            type="range"
            min="0"
            max="10"
            step="0.1"
            value={sliderValue}
            onChange={handleSliderChange}
            onMouseUp={handleSliderRelease}
            onTouchEnd={handleSliderRelease}
            className="slider"
            style={{
              background: `linear-gradient(to right, #15B1D7 ${
                sliderValue * 10
              }%, #FC6448)`,
              "--thumb-color": calculateGradientColor(), // Dynamic thumb color
            }}
          />

          <div className="range-labels">
            <p>No Pain</p>
            <p>Painful</p>
          </div>

          <div
            className="slider-bubble"
            style={{
              left: calculateBubblePosition(),
              color: calculateGradientColor(),
              transition: "left 0.2s ease-in-out, color 0.2s ease-in-out", // Add transition for smooth animation
            }}
          >
            <span style={{ color: calculateGradientColor() }}>
              {Math.round(sliderValue)}
            </span>
            <div className={`tooltip-icon ico ico-${Math.round(sliderValue)}`}>
              <span className={`icon icon-${Math.round(sliderValue)}`}></span>
            </div>
            <span style={{ color: calculateGradientColor() }}>
              {painLevels[Math.round(sliderValue)]}
            </span>
          </div>
        </div>
      </div>
      {/* <ul className="selection selection-flex-col selection-ico fade2 with-box-icon">
        {groupItems.map((painLevel, index) => (
          <li
            key={painLevel}
            className={`ico ico-${index} ${
              isActive(painLevel) ? "active" : ""
            }`}
            onClick={() => handleToggle(painLevel, index)}
          >
            <span className={`icon icon-${index}`}></span>
            <p className="icon-text">{painLevels[index]}</p>
          </li>
        ))}
      </ul> */}
      <div className="nav-container fade3">
        <button className="btn-next next-btn" onClick={handleNext}>
          Next
        </button>
      </div>
      <div className="dot-container fade3">
        <div className="dot-unchecked"></div>
        <div className="dot-unchecked"></div>
        <div className="dot-checked"></div>
        <div className="dot-unchecked"></div>
        <div className="dot-unchecked"></div>
        <div className="dot-unchecked"></div>
      </div>
    </div>
  );
};

export default OnboardingStep3;
